import { MINIMUM_DATE_CONTROL } from 'src/front/constant';
import * as Yup from 'yup';

const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(date.getDate() + days);
  return result;
};

// eslint-disable-next-line import/prefer-default-export
export const CardObservationSchema = Yup.object().shape({
  pos: Yup.object().nullable().required('general_requiredField_errorMessage'),
  beginDate: Yup.date().when('$todayMaxControl', (todayMaxControl: Date, schema: Yup.DateSchema) =>
    schema
      .nullable()
      .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
      .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
      .required('general_requiredField_errorMessage')
  ),
  endDate: Yup.date().when(
    ['beginDate', '$todayMaxControl'],
    (beginDate: Date, todayMaxControl: Date, schema: Yup.DateSchema) =>
      beginDate
        ? schema
            .nullable()
            .min(beginDate, 'general_endDateControl_errorMessage')
            .max(addDays(beginDate, 7), 'cardObservation_minDateInterval_errorMessage')
            .required('general_requiredField_errorMessage')
        : schema
            .nullable()
            .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
            .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
            .required('general_requiredField_errorMessage')
  ),
});
